import { Box,  Typography, Avatar, IconButton, useMediaQuery, Skeleton, Button, Tooltip} from "@mui/material";
import luciLogo from "../../assets/luciLogo2.png";
import { makeStyles } from "@mui/styles";
import { useMemo, useRef, useState } from "react";
import CollaboratorCard from "../events/components/CollaboratorCard";
import { Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import { backButtonLabel, resolveReturnTo } from "./backNavigation";
import { useDispatch, useSelector } from "react-redux";
import useUploadedList from "../../hooks/useUploadedList";
import useSequentialVideoUpload from "../../hooks/useSequentialVideoUpload";
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { useEffect } from "react";
import CustomUserCard from "../events/components/CustomUserCard";
import "@fontsource/rubik";
import AuthLayout from "../layouts/AuthLayout";
import useConsentDetail from "../events/hooks/useConsentDetail";
import EventDetailCard from "../events/components/EventDetailCard";
import FilmingTutorialCard from "../events/components/FilmingTutorialCard";
import VideoPlayer from "./components/VideoPlayer";
import RequestLog from "./components/RequestLog";
import SubmitChangeRequestCard from "./components/SubmitChangeRequestCard";
import FinalVideoCompletedCard from "./components/FinalVideoCompletedCard";
import useAcceptFinalVideo from "./hooks/useAcceptFinalVideo";
import useRevisionRequests from "./hooks/useRevisionRequests";
import { updateReviewState } from "../../redux/reviewSlice";
import PopupVideoPlayer from "../../components/PopupVideoPlayer";
import { updateState } from "../../redux/commonSlice";
import useCheckVideoArrival from "./hooks/useCheckVideoArrival";
import useEventDetails from "../events/hooks/useEventDetails";
import VideoEditedCompletedCard from "./components/VideoEditedCompletedCard";
import ReEditingStartedCard from "./components/ReEditingStartedCard";
import SubmitChangeRequestTutorialPopup from "./components/SubmitChangeRequestTutorialPopup";
import butterfly from './../../assets/butterfly_navigation.png'
import { checkNewVideoArrival, getEventDetails, viewProjectMembers } from "../events/actions";
import { getUserRoles } from "../../commonactions/actions";
import { setSnackbar } from "../../redux/messageSlice";
import { PERMISSION } from "../../constants/constants";
import usePermissions from "../../hooks/usePermissions";
import CustomProtectedRoute from "../../components/CustomProtectedRoute";
import ProjectMembersCard from "../events/components/ProjectMembersCard";
import InviteProjectMembersPopup from "../events/components/InviteProjectMembersPopup";
import ViewProjectMembersPopup from "../events/components/ViewProjectMembersPopup";
import AssignOwnerPopup from "../events/components/AssignOwnerPopup";
import RemoveUserConfirmationPopup from "../events/components/RemoveUserConfirmationPopup";
import OverrideConfirmationPopup from "../events/components/OverrideConfirmationPopup";
import RemoveOwnerPopup from "../events/components/RemoveOwnerPopup";
import ViewNotesToEditorPopup from "../events/components/ViewNotesToEditorPopup";
import UploadDocumentsPopup from "../events/components/UploadDocumentsPopup";
import VideoComparePopup from "./components/VideoComparePopup";
import EditingCyclesCard from "./components/EditingCyclesCard";
import useOrganisationProjectActions from "../events/useOrganisationProjectActions";
import CustomCard from "../events/components/CustomCard";
import useRevisionActions from "./useRevisionActions";
import EditorCheckListUploadPopup from "./components/EditorCheckListUploadPopup";
import useCommonActions from "../../commonactions/useCommonActions";
import CompareUserInputVideoPopup from "./components/CompareUserInputVideoPopup";
import { updateProjectState } from "../../redux/projectSlice";
import CustomButton from "../../components/CustomButton";
import UploadVideoChecklist from "./components/UploadVideoChecklist";
import AcceptVideoPopup from "./components/AcceptVideoPopup";
import RejectVideoPopup from "./components/RejectVideoPopup";
import BrandboxAssets from "./components/BrandboxAssets";
import EditImage from "../events/components/assets/EditImage";
import EditingProgressCard from "./components/EditingProgressCard";
import ViewSongDescriptionPopup from "../events/components/ViewSongDescriptionPopup";
import ViewSongsPopup from "../events/components/ViewSongsPopup";
import ViewDocumentsPopup from "../events/components/ViewDocumentsPopup";
import HideOnPharoahControl from "../events/components/HideOnPharoahControl";
import PharoahVisibilityUndoSnackbar from "../../components/PharoahVisibilityUndoSnackbar";
// import ApprovalCheckListPopup from "./components/ApprovalCheckListPopup";




const useStyles = makeStyles((theme) => ({
    container: {
      display:'flex',
      width:'100%',
      minWidth:'860px',
       height:'84vh',
     // height:'100%',  
  },
    center: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly'
    },
    leftContainer: {
        //  width:'21.1%',
          display:'flex',
          flexDirection:'column',
          justifyContent: 'flex-start',
          marginBottom:'41px',  
         // paddingLeft:'2.24%',
          height:'100%',
        
    },
    rightContainer:{
      // width:'77.2%',
      display:'flex',
      flexDirection:'column',
     // marginRight:'4.9%',
      marginBottom:'51px',
      marginLeft:'1.7%',
      height:'100%',
     
  },
    scroll: {
      overflowY: 'scroll',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '&::-webkit-scrollbar': {
        display: 'none'
      }
  
    }
  }));

const CompletedEventPage = () => {

  const params = useParams()
  const location = useLocation()
  const {projectId, orgId} = params
    const classes = useStyles()
    // const { videoTitle, videoSrc, } = props
    const [copyButtonText, setCopyButtonText] = useState("COPY LINK");
    const [shareButtonText, setShareButtonText] = useState("INVITE");
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [hasPermission] = usePermissions();
    const isMobileView = useMediaQuery('(max-width:899px)');
  
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const teamsReducer = useSelector((state) => state.root.teamsReducer);
    const projectReducer = useSelector((state) => state.projectReducer);
    const reviewEventReducer = useSelector((state) => state.reviewEventReducer);
    const permissionsReducer = useSelector((state) => state.permissionsReducer);
   // const [refetchEventDetail] = useEventDetails(commonReducer.production_event_id)
    const [eventData, setEventData] = useState({})
    // const [uploadedVideosArray, setUploadedVideosArray] = useState([]);
    // const [checkVideoArrival, recheckVideoArrival] = useCheckVideoArrival();
    // const [uploadedVideos, refetchList] = useUploadedList(true);
    const [getConsentDetails] = useConsentDetail();
    const statusRef = useRef();
    const finalVideoRef = useRef();
    const underRevisionRef = useRef(false)
    const isFromTeamsDashboard =  !!teamsReducer.selected_team ? true : false;
    // The board hands us the exact URL it was showing (filters and all) so Back returns
    // to the list the project was opened from — e.g. an editor's project list — rather
    // than resetting to the unfiltered dashboard.
    const returnTo = resolveReturnTo(location?.state?.returnTo);
    const backButtonTitle = backButtonLabel({
      returnTo,
      members: commonReducer?.organisation_members_list,
      isFromTeamsDashboard,
    });
    const [showPage, setShowPage] = useState(false)
    const {getProjectMembersList, getProjectDetails} = useOrganisationProjectActions()
    const {getEditingCyclesList, rejectInternalRevision} = useRevisionActions()
    const {getUserRoles} = useCommonActions()
    const [isActiveRevision, setIsActiveRevision] = useState(true)
    const [showEventDetails, setShowEventDetails] = useState(false)
    const onlyEventDetails = projectReducer?.project_details?.status_type_order < 3 || (reviewEventReducer?.editing_cycles_list?.length == 1 && reviewEventReducer?.internal_revisions_list?.length == 0)
      const [acceptFinalVideoMutate , acceptFinalVideoStatus] = useAcceptFinalVideo()
      const [renderPage, setRenderPage] = useState(false);
    

    useEffect(()=> {
      let currentRevision = reviewEventReducer?.internal_revisions_list?.find((item,i)=> reviewEventReducer?.internal_revision_id == item.id)
      console.log("active revision", currentRevision, !(currentRevision?.accepted || currentRevision?.rejected))
      if(!!currentRevision) {
       
        setIsActiveRevision(!(currentRevision.accepted || currentRevision.rejected))
      } 
    }, [reviewEventReducer?.internal_revision_id])

    const event = !!teamsReducer.selected_team ? teamsReducer.events?.find((event) => event.id == commonReducer.production_event_id) : commonReducer.events?.find((event) => event.id == commonReducer.production_event_id)

    useEffect(()=> {
       getUserRoles({scope: 'Project', event_id: projectId})
       getProjectMembersList({event_id: projectId}) ;
     if (!!projectId && !!orgId) {
      dispatch(updateState({production_event_id: projectId, selected_organisation: commonReducer?.organisation_list?.find(org=> org.id == orgId)}))
      getProjectDetails({id: projectId, organisation_id:orgId})
     // getEditingCyclesList({event_id: projectId, organisation_id:orgId})
    }
     
      //  getEditingCyclesList({event_id: commonReducer?.production_event_id, organisation_id:commonReducer?.selected_organisation?.id})
  },[projectId, orgId])
     
     
      useEffect(() => {
        statusRef.current = commonReducer.event_details?.status_type_order;
        if(statusRef.current === 4) {
          if(commonReducer.event_details.final_video_id === commonReducer.event_details.revision.revision_video_id) {
            //dispatch(updateState({new_video: false}));
            underRevisionRef.current =  commonReducer.event_details?.revision.submitted;
          } else {
            underRevisionRef.current =  false
          }
        }
    }, [commonReducer.event_details.status_type_order, commonReducer.event_details?.revision.submitted, commonReducer.event_details.final_video_id, commonReducer.event_details.revision.revision_video_id]);
    useEffect(()=> {
      finalVideoRef.current = commonReducer.event_details.final_video_id
    }, [commonReducer.event_details.final_video_id])

    // useEffect(()=>{
    //   getUserRoles(dispatch, navigate, permissionsReducer, {event_id: commonReducer?.production_event_id}, getUserCallback)
    // },[])
  
    // useEffect(()=> {
    //   getEventDetails({id: commonReducer.production_event_id}, dispatch);
      
    //  const intervalId = setInterval( () => {
    //     if(statusRef.current == 3 || (statusRef.current == 4 && underRevisionRef.current == true)) {
    //       checkNewVideoArrival({event_id: commonReducer.production_event_id, final_video_id: finalVideoRef.current}, dispatch)
    //     }
    //   }, 15000);
     
    //   return () => clearInterval(intervalId);
    
  
    // },[])
  

      // useEffect(()=> {
      //   if(commonReducer.new_video == true) {
      //     refetchEventDetail()
      //   }
      // }, [commonReducer.new_video])

    // useEffect(() => {
     
    //   setUploadedVideosArray(uploadedVideos) 
    // }, [uploadedVideos])
    
  
    // Editors may now open projects in any stage. "Editing not started" is exactly the
    // state Admin/QC already detect via `!internal_revision_id` (no edited video exists
    // yet). We mirror that same gate for editors so they see the identical
    // "Editing is yet to start" screen, with the upload button kept disabled.
    // Anyone who isn't Admin/QC is treated as an editor here, since the project-scoped
    // role may not resolve to 'Editor' before editing begins.
    const isEditorRole = commonReducer?.role_name !== 'Admin' && commonReducer?.role_name !== 'QC';
    const editingNotStarted = !reviewEventReducer?.internal_revision_id;
    const isEditorInProduction = isEditorRole && editingNotStarted;

    useEffect(() => {
      setRenderPage(true)
    }, [projectReducer?.project_details?.status_type_order,  commonReducer?.role_name])

    useEffect(()=> {
      if(reviewEventReducer.request_changes == true) {
        getEventDetails({id: projectId}, dispatch)
      }
    }, [reviewEventReducer.request_changes, projectId])
    
    useEffect(() => {
      const selectedEvent = commonReducer.event_details
    //   if (selectedEvent == null) {
    //     setEventData({ name: commonReducer.production_events[0]?.name, start: commonReducer.production_events[0]?.start_date, end: commonReducer.production_events[0]?.end_date, genre: commonReducer.production_events[0]?.genre, code: commonReducer.production_events[0]?.collab_code })
    //   } else 
      if (Object.keys(selectedEvent)?.length > 0) {
        // if(selectedEvent.consent_accepted == false) {
        //   getConsentDetails(commonReducer.production_event_id)
        // }
        setEventData({ name: selectedEvent.name, editor_start_date: selectedEvent.editor_start_date, start: selectedEvent.start_date, end: selectedEvent.end_date, eventType: selectedEvent.event_type, code: selectedEvent.collab_code, status: selectedEvent.status_type , consentStatus: selectedEvent.consent_accepted})
      }
     
    }, [ commonReducer.events])
  
    const videoAcceptHandler =  ()=>{
        //console.log('Video accepted')// send api req to accept video
        dispatch(updateReviewState({open_video_accept_popup :true}))
        // openInNewTab()
    }

    const uploadVideoHandler =  ()=>{
      // dispatch(updateProjectState({upload_video_popup :true}))
      dispatch(updateReviewState({show_video_checklist: true}))
   
  }

    const rejectVideoHandler = ()=>{
      dispatch(updateReviewState({open_video_reject_popup :true}))

        }

    // const copyInvite = ()=> {
    //   setShareButtonText("COPIED!")
    //   navigator.clipboard.writeText(`Hi! ${commonReducer.user_name} has invited you to be a contributor to their event. Please visit the given link and use following invitation code to collaborate to this event\n\nInvitation Code:  ${eventData.code}\n\n\n ${window.location.host}`)
    //   setTimeout(() => {
    //     setShareButtonText("INVITE")
    //   }, 1500)
    // }
  
    const shareClickHandler = () => {
      const dataToBeShared = {
       // title: "This title is for sharing",
        text: `Hi! ${commonReducer.user_name} has invited you to be a contributor to their event. Please visit the given link and use following invitation code to collaborate to this event\n\nInvitation Code:  ${eventData.code}\n\n\n`,
       // url: `/guestuploads?e=${commonReducer.production_event_id}&n=${eventData?.name?.replace(/ /g, "%20")}&s=${eventData?.start}&end=${eventData?.end}`,
        url: `/`
      };
      // Check if navigator.share is supported by the browser
    // console.log(navigator.share)
      if (navigator.share) {
        navigator
          .share(dataToBeShared)
          .then(() => {
          })
          .catch(() => {
          });
      } else {
       // console.log("Sorry! Your browser does not support Web Share API");
      }
    }
  
   const getUserCallback = (permission)=>{
    if(!permission[PERMISSION.PROJECT.REVISION.PAGE_VIEW])  {
      // console.log("slected team", teamsReducer.selected_team)
       isFromTeamsDashboard? navigate('/dashboard/teams') : navigate('/dashboard')
      dispatch(setSnackbar({flag: true, type: 'error', message: "ACCESS DENIED!"}))
    } else {
      setShowPage(true)
    }
   }


//    useEffect(()=> {
//     hasPermission(PERMISSION.PROJECT.MEMBER.VIEW) && viewProjectMembers({event_id: commonReducer.production_event_id}, dispatch, navigate, {commonReducer}) 
// },[permissionsReducer.permissions_master[PERMISSION.PROJECT.MEMBER.VIEW]])
  
 
    const backCLickHandler = ()=> {
      dispatch(updateReviewState({request_changes: false}))
      navigate(returnTo || "/dashboard", {replace: true})
    }

  // useEffect(()=> {
  //   if(!hasPermission(PERMISSION.PROJECT.REVISION.PAGE_VIEW) ) {
  //     console.log("slected team", teamsReducer.selected_team)
  //      !!teamsReducer.selected_team ? navigate('/dashboard/teams') : navigate('/dashboard')
  //     dispatch(setSnackbar({flag: true, type: 'error', message: "ACCESS DENIED!jakdshcbajkhda"}))
  //   }
  // }, [permissionsReducer.permissions_master, teamsReducer.selected_team])
    

  return (
  
   renderPage &&  <AuthLayout sx={{ padding: '2.5% 3.9% 2.1% 2.2%'}}>
        {/* <Box gap={2} className='flex row a-start j-end'>
                  <CustomUserCard/>
                </Box> */}
        <Box gap={2} className='flex row a-center' sx={{ px: {xs:1, sm:3}, justifyContent:'space-between' , }} >
              <Box textAlign='center' sx={{  width:{xs:'20%', md:'11%'}  }} >        
                          <img src={luciLogo}  width='100%' onClick={()=> dispatch(updateState({open_drawer_org_list: true}))}/>  
              </Box>
            <CustomUserCard />
        </Box>
                <Box container className={classes.container} sx={{marginTop:'15px'}}>
       { <Box className={classes.leftContainer} sx={{display:{xs:'flex', md:'flex'}, minWidth: projectReducer?.project_details?.status_type_order && '21%' }}>

       {projectReducer?.project_details?.status_type_order >=3 && projectReducer?.is_loading ? <CustomCard >
           <Skeleton  sx={{backgroundColor:'whitesmoke', mt: 6, ml:1, mr:1}} animation='pulse' variant="rounded" width='80%' height='20px' />
           <Skeleton  sx={{backgroundColor:'whitesmoke', mt: 2, ml:1, mr:1}} animation='pulse' variant="rounded" width='80%' height='20px' />
           <Skeleton  sx={{backgroundColor:'whitesmoke', mt: 2, ml:1, mr:1}} animation='pulse' variant="rounded" width='80%' height='20px' />
           <Skeleton  sx={{backgroundColor:'whitesmoke', mt: 2, ml:1, mr:1}} animation='pulse' variant="rounded" width='80%' height='20px' />
           <Skeleton  sx={{backgroundColor:'whitesmoke', mt: 2, ml:1, mr:1}} animation='pulse' variant="rounded" width='80%' height='20px' />
           <Skeleton  sx={{backgroundColor:'whitesmoke', mt: 4, ml:1, mr:1}} animation='pulse' variant="rounded" width='80%' height='20px' />
           <Skeleton  sx={{backgroundColor:'whitesmoke', mt: 2, ml:1, mr:1}} animation='pulse' variant="rounded" width='80%' height='20px' />
         </CustomCard> :
            <>
              {!onlyEventDetails && (
                <Tooltip title={showEventDetails ? 'View Edit Rounds' : 'View Event Info'} placement="left">
                  <Button
                    size="small"
                    variant="text"
                    color="secondary"
                    startIcon={showEventDetails
                      ? <AutorenewIcon sx={{fontSize: '11px !important'}}/>
                      : <InfoOutlinedIcon sx={{fontSize: '11px !important'}}/>
                    }
                    onClick={() => setShowEventDetails(v => !v)}
                    sx={{
                      fontSize: {xs:'7px', lg:'9px', xl:'11px'},
                      textTransform: 'none',
                      fontFamily: 'Rubik',
                      alignSelf: 'flex-end',
                      mb: 0.5,
                      px: 1,
                      py: 0.25,
                      borderRadius: '20px',
                      lineHeight: 1.5,
                      minWidth: 0,
                    }}
                  >
                    {showEventDetails ? 'Edit Rounds' : 'Event Info'}
                  </Button>
                </Tooltip>
              )}
              {onlyEventDetails ? <EventDetailCard eventData={eventData} event={event}/> : (
                <Box sx={{ flex: 1, minHeight: 0, position: 'relative', perspective: '1200px', overflow: 'hidden' }}>
                  <Box sx={{
                    width: '100%',
                    height: '100%',
                    transformStyle: 'preserve-3d',
                    WebkitTransformStyle: 'preserve-3d',
                    transition: 'transform 0.55s cubic-bezier(0.4, 0, 0.2, 1)',
                    transform: showEventDetails ? 'rotateY(180deg)' : 'rotateY(0deg)',
                  }}>
                    <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backfaceVisibility: 'hidden', WebkitBackfaceVisibility: 'hidden' }}>
                      <EditingCyclesCard eventData={eventData} projectId={projectId} orgId={orgId}/>
                    </Box>
                    <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backfaceVisibility: 'hidden', WebkitBackfaceVisibility: 'hidden', transform: 'rotateY(180deg)', overflowY: 'auto' }}>
                      <EventDetailCard eventData={eventData} event={event}/>
                    </Box>
                  </Box>
                </Box>
              )}
            </>  }
        </Box>
        }
  
        <Box className={classes.rightContainer} sx={{width:'100%'}}>
              <Box sx={{width:'100%', }}>
                <Box gap={1} sx={{display:'flex', justifyContent:'start', alignItems:'center', color:'black' }}>
                    <IconButton onClick={backCLickHandler}>
                      <KeyboardBackspaceOutlinedIcon sx={{color:'black',}}/>
                    </IconButton>
                    <Typography sx={{fontFamily: 'Rubik', fontSize:{xs:'10px',sm:'11px',md:'12px',lg:'14px',xl:'20px'}}}>{backButtonTitle}</Typography>
                </Box>
              </Box>
  
              {/* <Box style={{display:'flex', gap:'2.34%'}} sx={{ marginBottom:{xs:'15px',sm:'15px',md:'15px',lg:'20px',xl:'30px'},  marginTop:{xs:'8px', sm:'10px', md:'12px',lg:'14px',xl:'23px'}, width:'100%', }}>

                  <Box sx={{height:{xs:'90px',sm:'90px', md:'100px',lg:'15vh',xl:'18vh'}, width:'100%'}} container>
                       {projectReducer?.is_loading ? <CustomCard sx={{display:'flex', justifyContent:'space-between', paddingLeft:'10px', paddingRight:'10px', borderRadius:'5px', width:'100%'}}>
                       <Box sx={{display:'flex', flexDirection:'column', justifyContent:'space-evenly', height:'100%',  width:'50%', paddingLeft:'25px'}}>
                         <Skeleton sx={{backgroundColor:'whitesmoke'}} animation='pulse' variant="rounded" width='200px' height='20px'/>
                         <Skeleton sx={{backgroundColor:'whitesmoke'}} animation='pulse' variant="rounded" width='200px' height='20px'/>
                       </Box>
                       </CustomCard> : <VideoEditedCompletedCard message = {commonReducer?.event_details?.revision?.id == null || commonReducer?.event_details?.revision?.submitted != true ? "Your Lucivideo is ready!" : "Updates have been made to your Lucivideo."} />}
                  </Box>
              </Box> */}
  {/* /////////////////main box for review stage//////////////////////// */}
             {projectReducer?.is_loading ? <CustomCard sx={{height:{xs:'60%',sm:'60%',md:'70%',lg:'70%',xl:'64%'}, width:'100%', display:'flex', justifyContent:'center', alignItems:'center', borderRadius:'5px', }}>
                 <Box sx={{display:'flex', justifyContent:'space-evenly', width:'100%', height:'100%'}}>
                    <Skeleton sx={{backgroundColor:'whitesmoke', mt:2, ml:4, borderRadius:'5px'}} animation='pulse' variant="rounded" width='90%' height='70%' />
                    <Skeleton sx={{backgroundColor:'whitesmoke', mt:2, ml:6, mr:4,borderRadius:'5px'}} animation='pulse' variant="rounded" width='60%' height='90%' />
                 </Box>
                  </CustomCard>
            : (( commonReducer?.can_upload && reviewEventReducer?.show_video_checklist)   ? <UploadVideoChecklist/> : <Box sx={{display:'flex', height:{xs:'70%',sm:'70%',md:'100%',lg:'100%',xl:'100%'}, width:'100%',  backgroundColor:'#ffffffbf', boxShadow:'0px 5px 15px #00000029', borderRadius:'10px', alignItems:'center',flexDirection:'column', mt:1 }} >
                    <Box sx={{display:'flex', height:'20%', width:'100%',   position:'relative', alignItems:'center', justifyContent:'space-between'}}>

                      <Box  gap={{xs:0,md:1}} sx={{display:'flex', flexDirection:'column', paddingLeft:{xs:'10px',sm:'20px',md:'30px',lg:'34px',xl:'44px'}, paddingTop:{xs:'10px',sm:'10px',md:'15px',lg:'20px', xl:'20px'}, paddingBottom:{xs:'10px',sm:'10px',md:'10px',lg:'15px', xl:'15px'},height:'100%' , justifyContent:'center', alignItems:'start', width:'70%'}}>
                        <Box className='flex row' sx={{alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                         <Box sx={{ display:'flex', alignItems:'center', gap:'6px', overflow:'hidden' }}>
                           <Typography noWrap sx={{fontSize:{xs:'13px',sm:'14px',md:'14px',lg:'16px',xl:'20px'}, fontWeight:600, letterSpacing:0, fontFamily:'Rubik'}}>{`${projectReducer?.project_details?.name}`}</Typography>
                           {projectReducer?.project_details?.lucid_link_url && (
                             <Tooltip title="Open in Lucid" placement="top">
                               <Box component="a" href={projectReducer.project_details.lucid_link_url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} sx={{ display:'flex', alignItems:'center', color:'#555', textDecoration:'none', flexShrink:0 }}>
                                 <OpenInNewIcon sx={{ fontSize:{xs:'11px',sm:'12px',md:'13px',lg:'14px',xl:'18px'} }} />
                               </Box>
                             </Tooltip>
                           )}
                         </Box>
                         <Box sx={{ display:'flex', alignItems:'flex-start', gap:{xs:0.5, md:1.5}, flexShrink:0 }}>
                           {/* Hide from the dashboard — Admin only. Hiding removes the
                               project from every board and list, including the asker's own. */}
                           <HideOnPharoahControl
                             project={projectReducer?.project_details}
                             onChanged={(nextHidden) => dispatch(updateProjectState({ project_details: { ...projectReducer?.project_details, hidden_on_pharoah: nextHidden } }))}
                           />
                           <Button 
                             variant="text"
                               color='secondary'
                             onClick={()=> navigate('/brandbox')}
                             sx={{fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'20px',md:'22px',lg:'24px',xl:"32px"},  fontFamily:'Rubik', textTransform:'none', letterSpacing:'0.65px', textDecoration:'underline'}}
                           >
                             View Brand Guidelines
                           </Button>
                         </Box> 
                       </Box>
                         <Typography sx={{fontSize:{xs:'11px',md:'12px',lg:'13px',xl:'17px'}, display:'inline', textDecoration:'none', width:'100%', fontFamily:'Rubik', letterSpacing:'-0.05px'}}>{`${projectReducer?.project_details?.event_type?.name}`}</Typography>  
           
                     </Box>

          <Box  sx={{ display:'flex', alignItems:'flex-end', justifyContent:'center', height:'100%' ,width:'30%',  flexDirection:'column', mr: "5%"}}>    
{commonReducer?.role_name === 'Admin' && !commonReducer?.can_upload  ?
 <CustomButton 
      
      btnText='Accept Video'
      disabled = {!isActiveRevision || !reviewEventReducer?.internal_revision_id || (reviewEventReducer?.current_internal_revision?.accepted == true || reviewEventReducer?.current_internal_revision?.rejected == true)}
      onClick={videoAcceptHandler}    
      type='button'
      color='secondary'
      variant='contained'
      style={{
      borderRadius: '5px',
      border: "none",          
      textTransform:'none',
      }}
      sx={{fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'20px',md:'22px',lg:'24px',xl:"32px"}, width:{xs:'110px',sm:'130px',md:'150px',lg:'160px',xl:'195px'}, fontFamily:'Rubik', marginBottom:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}}}
    /> : 
  /* QC Send for Approval disabled — QC now accepts video like Admin */
  commonReducer?.role_name === 'QC' && !commonReducer?.can_upload  ?
 <CustomButton 
      
      btnText='Accept Video'
      disabled = {!isActiveRevision || !reviewEventReducer?.internal_revision_id || (reviewEventReducer?.current_internal_revision?.accepted == true || reviewEventReducer?.current_internal_revision?.rejected == true)}
      onClick={videoAcceptHandler}    
      type='button'
      color='secondary'
      variant='contained'
      style={{
      borderRadius: '5px',
      border: "none",          
      textTransform:'none',
      }}
      sx={{fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'20px',md:'22px',lg:'24px',xl:"32px"}, width:{xs:'110px',sm:'130px',md:'150px',lg:'160px',xl:'195px'}, fontFamily:'Rubik', marginBottom:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}}}
    /> :    <CustomButton
      btnText='Upload Video'
      disabled = {!commonReducer?.can_upload || isEditorInProduction}
      onClick={uploadVideoHandler}
      type='button'
      color='secondary'
      variant='contained'
      style={{
      borderRadius: '5px',
      border: "none",          
      textTransform:'none',
      }}
      sx={{fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'20px',md:'22px',lg:'24px',xl:"32px"}, width:{xs:'110px',sm:'130px',md:'150px',lg:'160px',xl:'195px'}, fontFamily:'Rubik', marginBottom:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}}}
    />}
   
  
       {(commonReducer?.role_name === 'Admin' || commonReducer?.role_name === 'QC') && !commonReducer?.can_upload && <Button 
        variant="text"
        disabled = {!isActiveRevision || !reviewEventReducer?.internal_revision_id || (reviewEventReducer?.current_internal_revision?.accepted == true || reviewEventReducer?.current_internal_revision?.rejected == true)}
        onClick={rejectVideoHandler}
        sx={{fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'20px',md:'22px',lg:'24px',xl:"32px"}, width:{xs:'110px',sm:'130px',md:'150px',lg:'160px',xl:'195px'}, fontFamily:'Rubik', textTransform:'none', letterSpacing:'0.65px', textDecoration:'underline'}}
        >
            or Request Edit
        </Button> }
    
          </Box>
                    </Box>
          { !reviewEventReducer?.internal_revision_id ? (
               <Box sx={{display:'flex', flexDirection:'row', width:'100%', height:'80%'}}>
                    {/* <Box sx={{height:'100%', width: '70%', display:"flex", alignItems: 'center' ,justifyContent:'center', px:3}}>
                       <Typography textAlign='center' variant="h3">Your Lucivideo is currently being edited!</Typography>
                    </Box>
                     <Box sx={{height:'100%', ml: 3, width:'30%', mr:3 }}>
                         <EditImage sx={{height: '100%', width: '100%'}} />
                    </Box> */}
                    <EditingProgressCard />
                  </Box>
          ) : (
                 <Box sx={{display:'flex', flexDirection:'row', width:'100%', height:'80%'}}>
                    <Box sx={{height:'100%', width: (reviewEventReducer.request_changes && commonReducer.event_details.status_type != "Complete" )? '70%':'70%', display:"flex", alignItems: 'flex-start' , paddingTop:'10px', justifyContent:'center', overflowY:'auto'}}>
                       <VideoPlayer/>
                    </Box>
                     <Box sx={{height:'100%', mr: 3, width:'30%' , maxHeight:'668px'}}>
                        <RequestLog disabled = {!isActiveRevision} />
                    </Box>
                  </Box>
          ) }
                
              </Box>
              )}
        
        </Box>  
        </Box> 
        {
            commonReducer.play_tutorial == true && <PopupVideoPlayer />
       }
       {reviewEventReducer.open_change_request_tutorial_popup == true && <SubmitChangeRequestTutorialPopup />}
              
       {projectReducer.invite_project_members_popup == true && <InviteProjectMembersPopup/>}

       {projectReducer.view_project_members_popup == true && <ViewProjectMembersPopup />}

       {projectReducer.assign_owner_popup == true && <AssignOwnerPopup/>}

       {projectReducer.remove_user_confirmation_popup == true && <RemoveUserConfirmationPopup/>}

       {projectReducer?.override_confirmation_popup && <OverrideConfirmationPopup />}

       {projectReducer.remove_owner_popup == true && <RemoveOwnerPopup/>}

       {projectReducer?.view_notes_to_editor_popup && <ViewNotesToEditorPopup event={event}/>}

       {projectReducer?.uploaded_documents_to_editor_popup && <ViewDocumentsPopup />}

       {projectReducer?.upload_video_popup && <EditorCheckListUploadPopup />}
       {projectReducer?.compare_videos_popup && <VideoComparePopup/>}
       {projectReducer?.compare_user_input_video_popup && <CompareUserInputVideoPopup/>}

       { reviewEventReducer.open_video_accept_popup && <AcceptVideoPopup open={reviewEventReducer.open_video_accept_popup} status = {acceptFinalVideoStatus == "loading"} />}
       { reviewEventReducer.open_video_reject_popup && <RejectVideoPopup open={reviewEventReducer.open_video_reject_popup}  status = {acceptFinalVideoStatus == "loading"} />}

       {projectReducer?.uploaded_songs_popup && <ViewSongsPopup />}

{projectReducer?.song_desc_popup && <ViewSongDescriptionPopup/>}
{/* projectReducer?.approver_checklist_popup && <ApprovalCheckListPopup/> */}

       <PharoahVisibilityUndoSnackbar />
     </AuthLayout> 

  )
}

export default CompletedEventPage